import TextHeadline from "canvas-core-react/lib/TextHeadline";
import React from "react";
import Row from "canvas-core-react/lib/Row";
import Column from "canvas-core-react/lib/Column";
import Margin from "canvas-core-react/lib/Margin";
import Grid from "canvas-core-react/lib/Grid";

export const TitleCustom = ({text, image}) => {
    return (
        <Margin lg={18} xs={18}>
            {image && (
                <Margin lg={18} xs={18}>
                    <Row className="align-items--center">
                        <Column>
                            <Grid fluid>{image}</Grid>
                        </Column>
                    </Row>
                </Margin>
            )}
            <TextHeadline
                style={{
                    textAlign: "center",
                    fontSize: "24px",
                }}
                component="h1"
            >
                {text}
                <Margin lg={18} xs={18}>
                    <hr
                        width={"34px"}
                        style={{margin: "auto", borderTop: "1px solid #EC111A"}}
                    />
                </Margin>
            </TextHeadline>
        </Margin>
    );
};
